/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents an API model for a value record of a claim attribute.
 */
export interface ClaimAttributeValueModel { 
    /**
     * ID of the object.
     */
    id: number;
    /**
     * String-represented value of the object.
     */
    value: string;
    /**
     * ID of the claim to which this value belongs.
     */
    claimId: number;
    /**
     * ID of the claim attribute that this value represents.
     */
    claimAttributeId: number;
    /**
     * IDs of claim documents that determine this value.
     */
    claimAttributeDocumentIds: Array<number>;
}

